// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 登录
 * @param params
 * @returns {*}
 */
export function login(params) {
  return axios.post('/system/login', params).then(res => res.data);
}
/**
 * 登出
 * @returns {*}
 */
export function logout() {
  return axios.get('/system/logout').then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/login.js